import { render, staticRenderFns } from "./item-adv.vue?vue&type=template&id=3a498797&scoped=true&"
import script from "./item-adv.vue?vue&type=script&lang=js&"
export * from "./item-adv.vue?vue&type=script&lang=js&"
import style0 from "./item-adv.vue?vue&type=style&index=0&id=3a498797&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a498797",
  null
  
)

export default component.exports